document.addEventListener('DOMContentLoaded', () => {
    const menuButton = document.querySelector('.menu_btn');
    const closeButton = document.querySelector('.close_btn');
    const navMenu = document.querySelector('.nav_menu');

    if (menuButton && navMenu) {
        menuButton.addEventListener('click', () => {
            navMenu.classList.toggle('active');
        });
    }
    if (closeButton && navMenu) {
        closeButton.addEventListener('click', () => {
            navMenu.classList.toggle('active');
        });
    }
    window.addEventListener("resize", () => { navMenu.classList.remove('active') });

    // Mobile menu: parent items (e.g. Laboratories) toggle their submenu
    document.querySelectorAll('.mobile_menu .menu-item-has-children > a').forEach(link => {
        const item = link.parentElement;
        const isOpen = item.classList.contains('current-menu-ancestor');

        item.classList.toggle('open', isOpen);
        link.setAttribute('aria-expanded', isOpen);

        link.addEventListener('click', (e) => {
            e.preventDefault();
            const open = item.classList.toggle('open');
            link.setAttribute('aria-expanded', open);
        });
    });

    // Desktop menu: "#" parent items only open the dropdown
    document.querySelectorAll('.desktop_menu .menu-item-has-children > a[href="#"]').forEach(link => {
        link.addEventListener('click', (e) => e.preventDefault());
    });

    const accordionContainers = document.querySelectorAll('[data-accordion]');
    
    accordionContainers.forEach(container => {
        const accordionItems = container.querySelectorAll('.accordion_item');
    
        accordionItems.forEach(item => {
            const title = item.querySelector('.accordion_title');
    
            if (title) {
                title.addEventListener('click', () => {
                    // Usuwanie klasy 'active' z innych elementów
                    accordionItems.forEach(otherItem => {
                        if (otherItem !== item) {
                            otherItem.classList.remove('active');
                        }
                    });
    
                    // Dodanie klasy 'active' do klikniętego elementu
                    item.classList.toggle('active');
                });
            }
        });
    });
});